import { Organization } from "./Organization";
import { AbstractCase } from "./AbstractCase";
import { OrganizationEmail } from "./OrganizationEmail";

export interface CaseOrganization{
  id: number;
  case: AbstractCase;
  organization: Organization;
  organizationEmail: OrganizationEmail;
  "@type"?: "CaseOrganization"; //optional because it only exists in json-ld responses
}

export function isJsonLdCaseOrganization(obj: unknown): obj is CaseOrganization {
  return !!obj && typeof obj === "object" && "@type" in obj && obj["@type"] === "CaseOrganization";
}
